import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class TextOption extends BaseOption {
  static userInterfaceComponent = {
    label: "Text",
    component: inspectorTools.RICH_TEXT_INPUT,
  };

  static defaultValue = "";

  // Context-bindable as a string: "make this text the story's title".
  static bindableDataType = "string";

  // Opt in to the Expression Editor affordance (evaluated + coerced to string).
  static expressionEditable = true;

  // A bound value arrives as a bare string, but every reader of this option
  // expects the iRichText shape (`initialValue.body_text`). Projection lives on
  // the option class, never in the resolver — each bindable option knows its own
  // value shape, and most take the string as-is.
  static projectBoundValue(value) {
    return { body_text: String(value ?? ""), ranges: [] };
  }
}
